export { restoreScrollBarPosition } from './src/index';
